import type { DesignationsRepository } from "../../domain/repositories/DesignationRepository";
import type { Designations } from "../../domain/entities/Designations";

export const getDesignations = async (
  repo: DesignationsRepository,
): Promise<Designations[]> => {
  return repo.getDesignations();
};